import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL, saveParams } from 'Types/APITypes';
import { useMutation, useQueryClient } from 'react-query';
import { QueryKeys } from 'Types';
import { GooglePlacesAddress } from 'Types/GooglePlaces';

async function saveGeoRetailLocation({ stNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/geo-retail-location`, baseURL };
  const res = await maestroApiCall(apiType, data).then((r) => r.data);
  return res;
}

export function useSaveGeoRetailLocation(stNumber: string) {
  const queryClient = useQueryClient();
  return useMutation(saveGeoRetailLocation, {
    onSuccess: () => queryClient.invalidateQueries([QueryKeys.stLocation, stNumber]),
  });
}

async function saveGeoCommercialLocation({ stNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/geo-retail-location?type=commercial`, baseURL };
  const res = await maestroApiCall(apiType, data).then((r) => r.data);
  return res;
}

export function useSaveGeoCommercialLocation(stNumber: string) {
  const queryClient = useQueryClient();
  return useMutation(saveGeoCommercialLocation, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.commercialLocation, stNumber]);
    },
  });
}

export async function getGeoLocation(address: GooglePlacesAddress) {
  const apiType: MaestroAPI = { method: 'POST', endpoint: '/googleGeoLocation', baseURL };
  const res = await maestroApiCall(apiType, address);
  return res.result;
}
